export const linksFilterInitialDataEndPoint =
  '/Merchant/GetLinksFilterInitialData';
